exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-container[data-v-5cb64616] {\n  max-width: 500px;\n}\n.sub-header[data-v-5cb64616] {\n  font-size: 0.8em;\n  margin-bottom: 10px;\n}\n.modal-body[data-v-5cb64616] {\n  padding: 16px 24px;\n}\n", ""]);

// exports
